import { intl } from "../../../intl";

export function formatFileSize(bytes, decimalPoint, hideSize) {
  if (bytes == 0) return "0 Bytes";
  var k = 1000,
    dm = decimalPoint || 2,
    sizes = ["Bytes", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return (
    parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) +
    " " +
    (hideSize ? "" : sizes[i])
  );
}

export function formatFileType(mimeType) {
  if (!mimeType)
    return intl.formatMessage({ id: "cloud.folder", defaultMessage: "Folder" });
  else {
    let typeArray = mimeType.split("/");
    if (!typeArray)
      return intl.formatMessage({
        id: "cloud.folder",
        defaultMessage: "Folder",
      });
    else {
      let type = typeArray[typeArray.length - 1];
      return type;
    }
  }
}
